import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuTrigger,
} from "~/components/shared/DropdownMenu";
import Icon from "~/components/shared/Icon";
import moment from "moment";

interface Props {
  onSelect: (value: string) => void;
}

const DEFAULT_RANGE_LABEL = "Past week";
const options = [
  {
    label: "Past hour",
    value: moment().subtract(1, "hours").toISOString(),
  },
  {
    label: "Past day",
    value: moment().subtract(1, "days").toISOString(),
  },
  {
    label: "Past week",
    value: moment().subtract(1, "weeks").toISOString(),
  },
];

export default function TimeRangeDropdown({ onSelect }: Props) {
  const [timeRange, setTimeRange] = useState(
    options.find(({ label }) => label === DEFAULT_RANGE_LABEL), // Default to past week
  );

  const handleChange = (option) => {
    setTimeRange(option);
    onSelect(option.value);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild={true}>
        <button className="btn btn-small btn-depth group inline-flex max-w-full items-center space-x-1 px-3">
          <span className="truncate">{timeRange?.label}</span>

          <Icon icon="down-triangle" className="flex-none" style={{ width: 7, height: 7 }} />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuPortal>
        <DropdownMenuContent align="start" alignOffset={1}>
          {options.map((option) => (
            <DropdownMenuItem
              id={option.label}
              key={option.label}
              asChild={true}
              active={timeRange === option}
            >
              <button onClick={() => handleChange(option)}>{option.label}</button>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}
